import { DataTableColumnHeader } from "@common/components/Table/DataTableColumnHeader";
import { formatDate } from "@common/components/utils";
import { ExpenseCategoryGlPairing } from "@common/utils/graphql";
import { ColumnDef } from "@tanstack/react-table";

export const categoriesTableColumns: ColumnDef<ExpenseCategoryGlPairing>[] = [
  {
    accessorKey: "categoryName",
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="Name" />;
    },
  },
  {
    accessorKey: "glAccount",
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="GL Account" />;
    },
  },
  {
    accessorKey: "updatedAt",
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="Last Modified" />;
    },
    cell: ({ row }) => <div>{formatDate(row.original.updatedAt)}</div>,
  },
  {
    accessorKey: "isShown",
    header: ({ column }) => {
      return <DataTableColumnHeader column={column} title="Disabled" />;
    },
    cell: ({ row }) => <div>{!row.original.isShown ? "Yes" : "No"}</div>,
  },
];
